import React, { useEffect } from 'react';
import { Category } from '../category';
import { IAncillaryGroupLevel } from '../nested-input';
import { SelectedAncillary } from './SelectedAncillary';
import { adaptAncillaryGroupToCategory } from './adapters/adaptAncillaryGroupToCategory';
import { IAncillaryGroup } from '../../../../domain/ancillary/domain/models/IAncillaryGroup';
import { trackViewAncillaries } from '../../shared/analytics/e-commerce/trackViewAncillaries';
import { useAncillariesFromFormData } from '../helpers/useAncillariesFromFormData';

interface IAncillaryGroupCategoryProps {
	ancillaryGroup: IAncillaryGroup;
	nestedInputLevel: IAncillaryGroupLevel;
}

export const AncillaryGroupCategory = ({
	ancillaryGroup,
	nestedInputLevel,
}: IAncillaryGroupCategoryProps) => {
	const category = adaptAncillaryGroupToCategory(
		ancillaryGroup,
		nestedInputLevel,
	);

	// Check if the ancillary group has a selected ancillary in the form data. If so, we want to show the extras for that ancillary.
	// If there is no selected ancillary for a group it will not be contained in the form data at all.
	// This is a bandage solution and the ancillaries flow should be refactored to be more intuitive and easier to work with.
	const selectedAncillaries = useAncillariesFromFormData();
	const selectedAncillary = ancillaryGroup.ancillaries.find(({ id }) =>
		selectedAncillaries.some((ancillary) => ancillary.id === id),
	);

	useEffect(() => {
		trackViewAncillaries(ancillaryGroup.ancillaries);
	}, [ancillaryGroup.ancillaries]);

	if (!ancillaryGroup.ancillaries.length) {
		return null;
	}

	const selectedAncillaryIndex =
		selectedAncillary && ancillaryGroup.ancillaries.indexOf(selectedAncillary);

	return (
		<>
			<Category
				defaultSubcategoryId={selectedAncillary?.id}
				category={category}
				nestedInputLevel={nestedInputLevel}
			/>
			{selectedAncillaryIndex !== undefined && selectedAncillary && (
				<SelectedAncillary
					ancillary={selectedAncillary}
					nestedInputLevel={{
						...nestedInputLevel,
						ancillaryIndex: selectedAncillaryIndex,
					}}
				/>
			)}
		</>
	);
};
